<template>
  <header class="navigation">
         <nav 
         class="navbar navbar-custom navbar-fixed-top" 
         v-bind:class="{ 'scroll-nav': scrolled}"
         >
            <div class="container">
               <div class="navbar-header">
                  <button type="button" class="navbar-toggle" id="show-modal" @click="showModal = true">
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  <span class="icon-bar"></span>
                  </button>
                  <router-link to="/"><a class="navbar-brand"><img src="../image/Discovr-Analytics-Logo.png" alt="logo"></a></router-link>
               </div>
                   <modal class="footer-div1" v-if="showModal" @close="showModal = false">
                     <h3>Menu</h3>
                     <br>
                     <h4>Services</h4>
                     <ul>
                        <li><router-link to="/Services/Analytics"><a @click="showModal = false">Analytics</a></router-link></li> 
                        <li><router-link to="/Services/Data-Science"><a @click="showModal = false">Data Science</a></router-link></li> 
                        <li><router-link to="/Services/Machine-Learning"><a @click="showModal = false">Machine Learning</a></router-link></li> 
                        <li><router-link to="/Services/Data-Management"><a @click="showModal = false">Data Management</a></router-link></li> 
                     </ul>
                     <br>
                     <h4>Company</h4>
                     <ul>
                        <li><router-link to="/White-Label-Business-Intelligence-Platform"><a @click="showModal = false" >White-label BI Platform</a></router-link></li>
                        <li><router-link to="/Content/Case-Studies"><a @click="showModal = false" >Case Studies</a></router-link></li>
                         <li><router-link to="/Content/Analyses"><a @click="showModal = false" >Analyses</a></router-link></li>
                        <li><router-link to="/Content/Guides"><a @click="showModal = false" >Guides</a></router-link></li>
                        <li><router-link to="/Content/Blog"><a @click="showModal = false" >Blog</a></router-link></li>
                        <li><router-link to="/Contact"><a @click="showModal = false" >Contact</a></router-link></li>
                     </ul>
                        <button class="modal-default-button" @click="showModal = false">Close Menu</button>
                        <br>
                  </modal>
                  <center>
               <div class="collapse navbar-collapse" id="myNavbar">
                  <ul class="nav navbar-nav menu-left">
                     <li><router-link to="/">Home</router-link></li>
                     <div class="dropdown1 navbar1">
                        <li class="dropbtn1">Services
                        <i class="fa fa-caret-down"></i>
                        </li>
                     <div class="dropdown-content1">
                        <router-link to="/Services/Analytics"><a>Analytics</a></router-link>
                        <router-link to="/Services/Data-Science"><a>Data Science</a></router-link>
                        <router-link to="/Services/Machine-Learning"><a>Machine Learning</a></router-link>
                        <router-link to="/Services/Data-Management"><a>Data Management</a></router-link>
                     </div>
                     </div>
                     <li><router-link to="/White-Label-Business-Intelligence-Platform">Platform</router-link></li>
                     <div class="dropdown1 navbar1">
                        <li class="dropbtn1">Content
                        <i class="fa fa-caret-down"></i>
                        </li>
                     <div class="dropdown-content1">
                        <router-link to="/Content/Case-Studies"><a>Case Studies</a></router-link>
                        <router-link to="/Content/Analyses"><a>Analyses</a></router-link>
                        <router-link to="/Content/Guides"><a>Guides</a></router-link>
                        <router-link to="/Content/Blog"><a>Blog</a></router-link>
                     </div>
                     </div>
                     <li><router-link to="/Contact">Contact</router-link></li>
                  </ul>
                 <ul class="nav navbar-nav navbar-right button-right">
                     <li><a href="/Contact">Enquire About Your Project</a></li>
                  </ul>
               </div>
                  </center>
            </div>
         </nav>
      </header>
</template>

<script>

export default {
  name: 'Nav',
  props: {
    msg: String
  },
  data: function () {
    return {
      scrolled: false,
      showModal: false
    }
  },
  methods: {
  handleScroll () {
    this.scrolled = window.scrollY > 10;
  }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
